import "@static/styles/style.css"
import { createStatic } from "@static/index"

createStatic().mount("#app")
